import React, { useState, useEffect, useCallback, Children } from "react";
import BluePlus from "../../../../../../Assets/Images/plus-blue.svg";
import Delete from "../../../../../../Assets/Images/delete.svg";
import Alert from "../../../ShareElements/Alert/Alert";
import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import { Config } from "../../../../../../Config";
import axios from "axios";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import NodesAddedRow from "../SharedElements/NodesAddedRow";

const Nodes = (props) => {
  const [MenuList, setMenuList] = useState([]);
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [PreviousModalId, setPrevModalId] = useState();
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  const [DuplicateIsOpen, setDuplicateIsOpen] = useState(false);
  const [Items, setItems] = useState([]);
  const [TotalElements, setTotalElements] = useState([]);
  const [AddedItems, setAddedItems] = useState([]);
  const [IndexOfItemToRemove, setIndexToRemove] = useState("");
  const [DeleteDupIsOpen, setDeleteDupIsOpen] = useState(false);
  const [DeleteAddedItem, setAddedItemToDelete] = useState();
  const [DeleteAddedItemIsOpen, setDeleteAddedItemIsOpen] = useState(false);
  const [ProfileName, setProfileName] = useState("");
  const [Parents, setParents] = useState([]);
  const [Childs, setChilds] = useState([]);
  const [ScopesTree, setScopesTree] = useState([]); //all parents and childs used for searching each parent's childs
  const [IsLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (window.localStorage.getItem("CreatedProfileNameString") !== null) {
      setProfileName(window.localStorage.getItem("CreatedProfileNameString"));
    }
    getAllChildsAndParents();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const checkPreviousNodes = (MenuItems) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/role/" +
        window.localStorage.getItem("CreatedProfileId") +
        "/scopes",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.length === 0) {
          fetchAllNodes();
        } else {
          setMenuList(Res.data);
          createPreviousNodes(Res.data, MenuItems);
          createTotalElements(Res.data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getAllChildsAndParents = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/scope/tree",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Parents = [];
        let Children = [];
        Res.data.map((Item) => {
          if (Item.children === !null) {
            Item.children.map((Child) => {
              Children.push(Child);
            });
          }
          Parents.push({ Name: Item.name, Id: Item.id });
        });
        setParents(Parents);
        setChilds(Children);
        setScopesTree(Res.data);
        checkPreviousNodes(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // creates the data required for previously saved nodes and childs
  const createPreviousNodes = (ResData, MenuItems) => {
    let List = [];
    ResData.map((Item) => {
      let ChildItems = MenuItems.filter((MenuItem) => {
        return MenuItem.id === Item.parentId;
      });
      let Record = {
        Name: Item.parentName,
        Id: Item.parentId,
        Children: ChildItems[0].children,
        SelectedChild: Item.name,
        SelectedChildId: Item.id,
        Permission: Item.visibility,
      };
      List.push(Record);
    });
    setItems(List);
  };

  const fetchAllNodes = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/scope/tree",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setMenuList(Res.data);
        createNodeItems(Res.data);
        createInitialPageData(Res.data);
        createTotalElements(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const createTotalElements = (Data) => {
    for (let i = 0; i < Data.length; i++) {
      TotalElements.push("Item");
    }
  };
  const createInitialPageData = (APIdata) => {
    console.log(APIdata);
    let List = [];
    let Parents = [];
    let Children = [];

    APIdata.map((Item) => {
      List.push({
        Name: Item.name,
        Id: Item.id,
        Children: Item.children,
        SelectedChild: translateText("not_specified"),
        Permission: translateText("not_specified"),
        SelectedChildId: null,
      });
      Item.children.map((Child) => {
        Children.push(Child);
      });
      Parents.push({ Name: Item.name, Id: Item.id });
    });
    setItems(List);
    setParents(Parents);
    setChilds(Children);
  };
  // Creates the main data displayed on the page as node parents and childs
  const createNodeItems = (NodesList) => {
    let List = [];
    NodesList.map((Item) => {
      List.push({
        Name: Item.name,
        Id: Item.id,
        Children: Item.children,
        SelectedChild: translateText("not_specified"),
        Permission: translateText("not_specified"),
        SelectedChildIndex: null,
      });
    });
    setItems(List);
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  // this function searches for the selected parent's childs based on their index (i)
  const handleParentChange = (i) => {
    enableSave();
    resetParentSelectStyles(i);
    let Keyword = document.getElementById(
      "select-parent-" + i + "-filter"
    ).value;
    var Data = ScopesTree;
    var Filter = "id";
    var SelectedParent = Data.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    let SelectedParentChilds = [];
    SelectedParent[0].children.map((Child) => {
      // exception for security profiles item not to be pushed in the data
      if (Child.name !== "Security Profiles") {
        SelectedParentChilds.push({ name: Child.name, id: Child.id });
      }
    });
    document.getElementById("select-child-" + i + "-filter").options.length = 0;
    SelectedParentChilds.map((Child, index) => {
      document.getElementById("select-child-" + i + "-filter").options[index] =
        new Option(Child.name, Child.id);
    });
  };
  const resetParentSelectStyles = (i) => {
    document.getElementById("select-parent-" + i + "-filter").style.border =
      "1px solid #dde2eb";
    document.getElementById("validation-parent-" + i).style.display = "none";
    resetChildSelectStyles(i);
  };
  const resetChildSelectStyles = (i) => {
    document.getElementById("select-child-" + i + "-filter").style.border =
      "1px solid #dde2eb";
    document.getElementById("validation-child-" + i).style.display = "none";
  };
  const resetPermissionSelectStyles = (i) => {
    document.getElementById(
      "select-permissions-" + i + "-filter"
    ).style.border = "1px solid #dde2eb";
    document.getElementById("validation-permission-" + i).style.display =
      "none";
  };
  const handleChildChange = (i) => {
    enableSave();
    resetChildSelectStyles(i);
    let PreviousData = [...Items, ...AddedItems];
    let PreviousChildName = document.getElementById(
      "select-child-" + i + "-filter"
    ).options[
      document.getElementById("select-child-" + i + "-filter").options
        .selectedIndex
    ].innerText;
    let PreviousChildId = document.getElementById(
      "select-child-" + i + "-filter"
    ).value;

    PreviousData[i].SelectedChild = PreviousChildName;
    PreviousData[i].SelectedChildId = PreviousChildId;

    setAddedItems([]);
    setItems(PreviousData);
  };
  const handlePermissionChange = (i) => {
    enableSave();
    resetPermissionSelectStyles(i);

    let PreviousData = [...Items, ...AddedItems];
    let PreviousPremission = document.getElementById(
      "select-permissions-" + i + "-filter"
    ).value;

    PreviousData[i].Permission = PreviousPremission;

    setItems(PreviousData);
    setAddedItems([]);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setUnsavedChanges(true);
    } else {
      window.localStorage.removeItem("CreatedProfileId");
      window.localStorage.removeItem("CreatedProfileNameString");
      window.localStorage.removeItem("CreatedProfileDesc");
      window.location.assign("/home/securityProfiles");
    }
  };
  const discardAndLeave = () => {
    window.location.assign("/home/securityProfiles");
  };
  // Opens and closes the small modal displayed for each row in the table based on conditions
  const openModal = (i) => {
    setPrevModalId("modal-" + i);
    console.log(i);
    if (PreviousModalId !== undefined) {
      if (document.getElementById("modal-" + i).style.display === "block") {
        document.getElementById("modal-" + i).style.display = "none";
      } else if (
        document.getElementById("modal-" + i).style.display === "none" &&
        PreviousModalId === "modal-" + i
      ) {
        document.getElementById("modal-" + i).style.display = "block";
      } else {
        if (
          document.getElementById("modal-" + i) !== null &&
          document.getElementById(PreviousModalId) !== null
        ) {
          document.getElementById("modal-" + i).style.display = "block";
          document.getElementById(PreviousModalId).style.display = "none";
        }
      }
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
  };
  const showDeleteAlert = (i) => {
    setIndexToRemove(i);
    document.getElementById("modal-" + i).style.display = "none";
    setDeleteIsOpen(true);
  };
  const cancelDelete = () => {
    setDeleteIsOpen(false);
  };
  const acceptDelete = () => {
    let List = [...Items];
    if (IndexOfItemToRemove > -1) {
      List.splice(IndexOfItemToRemove, 1);
      setItems(List);
    }
    enableSave();
    setPrevModalId(undefined); // to reset the progress of opening context menu ( openModal() )
    setItems(List);
    setDeleteIsOpen(false);
  };
  const close = () => {
    setUnsavedChanges(false);
  };
  const displayAdd = () => {
    enableSave();
    setDuplicateIsOpen(!DuplicateIsOpen);
    let List = AddedItems;
    let NewItemIndex = TotalElements.length;
    TotalElements.push("ITEM");
    List.push({
      Name: translateText("not_specified"),
      Id: NewItemIndex,
      Children: [],
      Duplicates: [],
      SelectedChild: translateText("not_specified"),
      Permission: translateText("not_specified"),
      SelectedChildIndex: null,
    });
    setAddedItems(List);
  };
  const duplicateItem = (MenuItem, i, IsAddedRow) => {
    enableSave();
    setItems((data) => {
      let RowsData = [...data];
      const Name = `${
        document.getElementById("select-parent-" + i + "-filter").options[
          document.getElementById("select-parent-" + i + "-filter").options
            .selectedIndex
        ].innerText
      }`;
      const Id = `${
        document.getElementById("select-parent-" + i + "-filter").value
      }`;
      const SelectedChildId = `${
        document.getElementById("select-child-" + i + "-filter").value
      }`;
      const SelectedChild = `${
        document.getElementById("select-child-" + i + "-filter").options[
          document.getElementById("select-child-" + i + "-filter").options
            .selectedIndex
        ].innerText
      }`;
      const Permission = `${
        document.getElementById("select-permissions-" + i + "-filter").value
      }`;
      let ItemIds = [];
      Items.map((Item) => {
        ItemIds.push(Item.Id);
      });
      var Children;
      if (IsAddedRow) {
        Children = [...Childs];
      } else {
        Children = Items[ItemIds.indexOf(Id)].Children;
      }

      const IndexToPush = parseInt(i + 1);
      RowsData.splice(IndexToPush, 0, {
        ...MenuItem,
        Name,
        Id,
        Children,
        SelectedChildId,
        SelectedChild,
        Permission,
      });
      return RowsData;
    });
  };
  const validateEntries = () => {
    let Size = parseInt(Items.length + AddedItems.length);
    for (let i = 0; i < Size; i++) {
      if (document.getElementById("select-child-" + i + "-filter") !== null) {
        let Value = document.getElementById(
          "select-child-" + i + "-filter"
        ).value;
        console.log(Value);
        if (Value === translateText("not_specified")) {
          document.getElementById(
            "select-child-" + i + "-filter"
          ).style.border = "1px solid #ff7474";
          document.getElementById("validation-child-" + i).style.display =
            "block";
        }
      }
    }
    for (let i = 0; i < Size; i++) {
      if (
        document.getElementById("select-permissions-" + i + "-filter") !== null
      ) {
        let Value = document.getElementById(
          "select-permissions-" + i + "-filter"
        ).value;
        console.log(Value);
        if (Value === translateText("not_specified")) {
          document.getElementById(
            "select-permissions-" + i + "-filter"
          ).style.border = "1px solid #ff7474";
          document.getElementById("validation-permission-" + i).style.display =
            "block";
        }
      }
    }
    for (let i = 0; i < Size; i++) {
      if (document.getElementById("select-parent-" + i + "-filter") !== null) {
        let Value = document.getElementById(
          "select-parent-" + i + "-filter"
        ).value;
        if (Value === translateText("not_specified")) {
          document.getElementById(
            "select-parent-" + i + "-filter"
          ).style.border = "1px solid #ff7474";
          document.getElementById("validation-parent-" + i).style.display =
            "block";
        }
      }
    }
    saveNodes();
  };
  const saveNodes = () => {
    setIsLoading(true);
    let Data = [];
    for (let i = 0; i < parseInt(Items.length + AddedItems.length); i++) {
      if (document.getElementById("select-child-" + i + "-filter") !== null) {
        Data.push({
          id: document.getElementById("select-child-" + i + "-filter").value,
          parentId: document.getElementById("select-parent-" + i + "-filter")
            .value,
          visibility: document.getElementById(
            "select-permissions-" + i + "-filter"
          ).value,
        });
      }
    }
    console.log(Data);
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/role/" +
        window.localStorage.getItem("CreatedProfileId") +
        "/scopes",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        disableSaveBtn();
        setIsLoading(false);
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
      });
  };
  const acceptDeleteDuplicate = () => {
    setDeleteDupIsOpen(false);
  };
  const cancelDeleteDuplicate = () => {
    setDeleteDupIsOpen(false);
  };
  const showDeleteAddedItem = (item, ModalId) => {
    setAddedItemToDelete(item);
    TotalElements.splice(0, 1);
    setDeleteAddedItemIsOpen(true);
  };
  const acceptDeleteAddedItem = () => {
    setDeleteAddedItemIsOpen(false);
    let Rows = [...AddedItems];
    let Index = Rows.indexOf(DeleteAddedItem);
    Rows.splice(Index, 1);
    setAddedItems(Rows);
  };
  const cancelDeleteAddedItem = () => {
    setDeleteAddedItemIsOpen(false);
  };
  const removeDuplicate = (Scope, Name) => {
    if (Name === Scope.Name) {
      return null;
    } else {
      return (
        <option key={Scope.Id} value={Scope.Id}>
          {Scope.Name}
        </option>
      );
    }
  };
  return (
    <div className="form">
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => close()}
          saveAndLeave={() => discardAndLeave()}
          discardAndLeave={() => discardAndLeave()}
          LangData={props.LangData}
        />
      ) : null}
      {DeleteIsOpen ? (
        <Alert
          acceptDelete={() => acceptDelete()}
          cancelDelete={() => cancelDelete()}
          LangData={props.LangData}
          IsDelete
        />
      ) : null}
      {DeleteAddedItemIsOpen ? (
        <Alert
          acceptDelete={() => acceptDeleteAddedItem()}
          cancelDelete={() => cancelDeleteAddedItem()}
          LangData={props.LangData}
          IsDelete
        />
      ) : null}
      {DeleteDupIsOpen ? (
        <Alert
          acceptDelete={() => acceptDeleteDuplicate()}
          cancelDelete={() => cancelDeleteDuplicate()}
          LangData={props.LangData}
          IsDelete
        />
      ) : null}
      <section className="form-header">
        <button className="return" onClick={() => cancelOperation()}>
          <i className="feather-arrow-left"></i>
        </button>
        {ProfileName.length === 0 ? (
          <h1>New Profile</h1>
        ) : (
          <h1>{ProfileName}</h1>
        )}
        <div className="action-btn-group">
          <button onClick={() => cancelOperation()} className="cancel">
            {translateText("cancel")}
          </button>
          {IsLoading ? (
            <button
              onClick={() => null} //this button is disabled and won't act when loading is set to true
              id="save-btn"
              className="save no-action"
            >
              <img alt="" className="rotator" src={Rotator} />
            </button>
          ) : (
            <button
              onClick={() => validateEntries()}
              id="save-btn"
              className="save disabled"
            >
              {translateText("save")}
            </button>
          )}
        </div>
      </section>
      <div className="form-row titles nodes-row">
        <section className="xlarge left">
          <p>{translateText("parent")}</p>
        </section>
        <section className="xlarge left">
          <p>{translateText("child")}</p>
        </section>
        <section className="large left-single">
          <p>{translateText("permissions")}</p>
        </section>
        <section className="large left-last">
          <p>{translateText("duplicate")}</p>
        </section>
      </div>
      <React.Fragment>
        <React.Fragment>
          <React.Fragment>
            {Items.map((MenuItem, i) => (
              <React.Fragment>
                <div key={MenuItem.Name} className="form-row">
                  <div className="xlarge select-holder">
                    <select
                      id={"select-parent-" + i + "-filter"}
                      onChange={() => handleParentChange(i)}
                    >
                      <option value={MenuItem.Id}>{MenuItem.Name}</option>
                      {Parents.map((Scope) => (
                        <React.Fragment>
                          {removeDuplicate(Scope, MenuItem.Name)}
                        </React.Fragment>
                      ))}
                    </select>
                    <i className="feather-chevron-down cx-select-icon"></i>
                    <p
                      className="validation-error"
                      id={"validation-parent-" + i}
                    >
                      {translateText("specify_parent_error")}.
                    </p>
                  </div>
                  <div className="xlarge select-holder">
                    <select
                      id={"select-child-" + i + "-filter"}
                      onChange={() => handleChildChange(i)}
                    >
                      <option
                        selected
                        disabled={
                          MenuItem.SelectedChild ===
                          translateText("not_specified")
                            ? true
                            : false
                        }
                        value={MenuItem.SelectedChildId}
                      >
                        {MenuItem.SelectedChild}
                      </option>
                      {MenuItem.Children.map((Child) => (
                        <React.Fragment>
                          {Child.name === MenuItem.SelectedChild ? null : (
                            <>
                              {Child.name === "Security Profiles" ? null : (
                                <option key={Child.id} value={Child.id}>
                                  {Child.name}
                                </option>
                              )}
                            </>
                          )}
                        </React.Fragment>
                      ))}
                    </select>
                    <i className="feather-chevron-down cx-select-icon"></i>
                    <p
                      className="validation-error"
                      id={"validation-child-" + i}
                    >
                      {translateText("specify_child_error")}.
                    </p>
                  </div>
                  <div className="xlarge select-holder">
                    <select
                      id={"select-permissions-" + i + "-filter"}
                      onChange={() => handlePermissionChange(i)}
                      defaultValue={
                        MenuItem.Permission === translateText("not_specified")
                          ? undefined
                          : MenuItem.Permission === "UnHide"
                          ? "UnHide"
                          : "Hide"
                      }
                    >
                      {MenuItem.Permission ===
                      translateText("not_specified") ? (
                        <option selected disabled>
                          {translateText("not_specified")}
                        </option>
                      ) : null}
                      <option value="Hide">{translateText("hide")}</option>
                      <option value="UnHide">{translateText("Unhide")}</option>
                    </select>
                    <i className="feather-chevron-down cx-select-icon"></i>
                    <p
                      className="validation-error"
                      id={"validation-permission-" + i}
                    >
                      {translateText("specify_permission_error")}.
                    </p>
                  </div>
                  <section className="large left-last">
                    <button onClick={() => duplicateItem(MenuItem, i, false)}>
                      <i className="feather-copy"></i>
                    </button>
                    <button onClick={() => openModal(i)}></button>
                  </section>
                  <div className="more-info">
                    <div className="modal-space" id={"modal-" + i}>
                      <div className="modal-body double-item">
                        <button
                          className="btn"
                          onClick={() => showDeleteAlert(i)}
                        >
                          <img alt="" src={Delete} />
                          <div className="btn-text">
                            <p>{translateText("delete")}</p>
                            <p>{translateText("delete_this_record")}</p>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))}
            {AddedItems.length > 0 ? (
              <React.Fragment>
                {AddedItems.map((Item, i) => (
                  <NodesAddedRow
                    i={i}
                    Delete={Delete}
                    Item={Item}
                    Items={Items}
                    Index={parseInt(i + Items.length)}
                    HandleParentChange={(Index) => handleParentChange(Index)}
                    HandleChildChange={(Index) => handleChildChange(Index)}
                    Parents={Parents}
                    HandlePermissionChange={(Index) =>
                      handlePermissionChange(Index)
                    }
                    DuplicateItem={(Item, Index) =>
                      duplicateItem(Item, Index, true)
                    }
                    ShowDeleteAddedItem={(Item, Index) =>
                      showDeleteAddedItem(Item, Index)
                    }
                    LangData={props.LangData}
                  />
                ))}
              </React.Fragment>
            ) : null}
            <button
              onClick={() => displayAdd()}
              className="add-to-list xxlarge-btn"
            >
              <img alt="" src={BluePlus} />
              {translateText("add")}
            </button>
          </React.Fragment>
        </React.Fragment>
      </React.Fragment>
    </div>
  );
};
export default Nodes;
